// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1e98i","col":"Table_col__29_MR","fulfillmentStatus":"Table_fulfillmentStatus__2I5Z_","emailCol":"Table_emailCol__K8XJy"};